import { configureStore } from '@reduxjs/toolkit';
import CryptoJS from 'crypto-js';
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { apiCalling } from '../commonRedux/getRTKApi/baseApi';
import { rootReducer } from './rootReducer';
import { rustApiCalling } from 'common/commonRedux/getRTKApi/rustApi';
const sKey: any = process.env.REACT_APP_DISCOUNT_NAME;
const encrypt = createTransform(
  (inboundState,) => {
    if (!inboundState) return inboundState;
    const cryptedText = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      sKey
    );
    return cryptedText.toString();
  },
  (outboundState: any,) => {
    if (!outboundState) return outboundState;
    const bytes = CryptoJS.AES.decrypt(outboundState, sKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }
);
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'localStorage','theme','dateFormatter','fontSize'],
  // blacklist: ['filter'],
  transforms: [encrypt],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleware = (getDefaultMiddleware:any) => [
  ...getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
    thunk: true,
  }),
  apiCalling.middleware,
  rustApiCalling.middleware,
];
const store = configureStore({
  reducer: persistedReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export default store;
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch